import React, { useEffect, useRef, useState } from 'react'
import { FileUpload } from 'primereact/fileupload';
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import AdminChapterTitlesBase from '../../core/admin/AdminChapterTitlesBase'
import { useParams } from 'react-router-dom';
import { isAuthenticated } from '../../auth/helper';
import { deleteBulkChapterBanners, deleteChapterBanner, deleteChapterPhoto, getChapterBanners, uploadMultipleChapterBanners, uploadMultipleChapterPhotos } from '../helper/adminapicalls';

import { Tag } from "primereact/tag";
import { IMAGESPATH } from '../../backend';
const ChapterBanner = () => {
  const { user, token } = isAuthenticated();
  const chapterParams = useParams();

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [submitted, setSubmitted] = useState(false)


  const [chapterBanner, setChapterBanner] = useState({
    _id: "",
    name: "",
    imageName: "",
    path: "",
    error: "",
    formData: "",
  });

  const {
    _id,
    name,
    imageName,
    path,
    error,
    formData,
  } = chapterBanner;


  const [chapterBanners, setChapterBanners] = useState(null)
  const [ChapterBannerDialog, setChapterBannerDialog] = useState(false);

  const [deleteChapterBannerDialog, setDeleteChapterBannerDialog] = useState(false);

  const [deleteChapterBannersDialog, setDeleteChapterBannersDialog] = useState(false);
  const [selectedChapterBanners, setSelectedChapterBanners] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);

  const fileUploader = useRef(null);
  const toast = useRef(null);
  const dt = useRef(null);

  const handleFileChange = (e) => {
    setSelectedFiles([...selectedFiles, ...e.files]);
  };

  const preload = () => {
    getChapterBanners(user._id, token, chapterParams.chapterId)
      .then((data) => {
          setChapterBanners(data);
      })
      .catch((err) => console.log(err));
    }

  useEffect(() => {
    preload()
  },[])

  function copyToClipboard(text) {
    if(navigator.clipboard) {
        navigator.clipboard.writeText(text);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Copied URL",
          life: 2000,
        });
    }
}

  
  const handleFileUpload = (event) => {
    try {
      setSubmitted(true);
      const formData = new FormData();
      selectedFiles.forEach((file) => {
        formData.append('photos', file, file.name);
      });
      uploadMultipleChapterBanners(user._id, chapterParams.chapterId, token, formData).then((res) => { 
        fileUploader.current.clear();
        setSelectedFiles([])
        setSubmitted(false)
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Banners Uploaded",
          life: 3000,
        });
        preload()
      });
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const deleteChapterBannerDB = () => {
    console.log(chapterBanner)
    deleteChapterBanner(user._id, token, chapterBanner._id)
      .then((data) => {
        if (data.error) {
          toast.current.show({
            severity: "error",
            summary: "Chapter Banner Not Deleted",
            detail: data.error,
            life: 5000,
          });
          setDeleteChapterBannerDialog(false);
        } else {
          preload();
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Chapter Banner Deleted",
            life: 3000,
          });
          setDeleteChapterBannerDialog(false);
        }
      })
      .catch((err) => console.log(err));
  }
  
  const deleteSelectedChapterBanners = () => {
    let chapterBanners = selectedChapterBanners;
    const chapterBannerIds = [];
    {
      Object.entries(chapterBanners).map(([key, value]) =>
        chapterBannerIds.push(chapterBanners[key]._id)
      );
    }
    deleteBulkChapterBanners(user._id, token, chapterBannerIds)
      .then((data) => {
        if (data.error) {
          toast.current.show({
            severity: "error",
            summary: "Chapter Banners Not Deleted",
            detail: data.error,
            life: 5000,
          });
          setDeleteChapterBannersDialog(false);
        } else {
          preload();
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Chapter Banners Deleted",
            life: 3000,
          });
          setDeleteChapterBannersDialog(false);
        }
      })
      .catch((err) => console.log(err));
  };
 

  const editChapterBanner = (chapterBanner) => {
    setChapterBanner({ ...chapterBanner });
    setChapterBannerDialog(true);
  };

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0">Manage Chapter Banners</h4>
     
    </div>
  )

  // ============START OF TOOLBARS ==================
  const leftToolbarTemplateChapter = () => {
    return (
      <div className="flex flex-wrap gap-2">
        {/* <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          className="m-2"
          onClick={openNewChapter}
        /> */}
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          className="m-2"
          onClick={confirmDeleteSelectedChapterBanners}
          disabled={!selectedChapterBanners || !selectedChapterBanners.length}
        />

        
      </div>
    );
  };
   // =========================START OF DIALOGS OPEN AND HIDE ==================
  

  const hideDialogChapterBanner = () => {
    setSubmitted(false);
    setChapterBannerDialog(false);
  };

  const hideDeleteChapterBannerDialog = () => {
    setDeleteChapterBannerDialog(false);
  };

  const hideDeleteChapterBannersDialog = () => {
    setDeleteChapterBannersDialog(false);
  };

  // =========================END OF DIALOGS OPEN AND HIDE ==================

  // ============START OF CONFIRMATIONS DIALOGS OPEN AND HIDE ==================
  
  const ChapterBannerDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={hideDialogChapterBanner}
      />
      <Button label="Save" icon="pi pi-check" />
    </React.Fragment>
  );

  const deleteChapterBannerDialogFooter = () => {
    return (<React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteChapterBannerDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteChapterBannerDB}
      />
    </React.Fragment>
  )
  };

  const deleteChapterBannersDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteChapterBannersDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedChapterBanners}
      />
    </React.Fragment>
  );

  const confirmDeleteChapterBanner = (ChapterBanner) => {
    setChapterBanner(ChapterBanner);
    setDeleteChapterBannerDialog(true);
  };

  const confirmDeleteSelectedChapterBanners = () => {
    setDeleteChapterBannersDialog(true);
  };

  const actionBodyTemplateChapterBanner = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-copy"
          rounded
          outlined
          className="mr-2"
          onClick={() =>  copyToClipboard(`%i${IMAGESPATH}/${rowData.imageName}%i`)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteChapterBanner(rowData)}
        />
      </React.Fragment>
    );
  };

  // ============END OF CONFIRMATIONS DIALOGS OPEN AND HIDE ==================

 

  // ============START OF STATUS SEVERITY ==================
 
  const imageBodyTemplate = (rowData) => {
    return (
      <img
        src={`${IMAGESPATH}/${rowData.imageName}`}
        alt={rowData.photo}
        width="64px"
        className="shadow-4"
      />
    );
  };


  const imageURLTemplate = (rowData) => {
    return (
      <div>
      <p>{`${IMAGESPATH}/${rowData.imageName}`} </p> 
      </div>
    );
  };

  // ============END OF STATUS SEVERITY ==================



  return (
    <AdminChapterTitlesBase>
        <div className="card">
        <Toast ref={toast} />
        <FileUpload
              name="photo"
              ref={fileUploader}
              customUpload="true"
              onSelect={handleFileChange}
              onUpload={(e) => console.log(e)}
              uploadHandler={handleFileUpload}
              accept="image/*"
              maxFileSize={2000000}
              multiple
              emptyTemplate={
                <p className="m-0">Drag and drop files to here to upload.</p>
              }
            />
            {submitted && !selectedFiles && (
              <small className="p-error">Atleast one image is required.</small>
            )}
        </div>

        {/*  START OF DATA TABLE  */}
        <div className="card">
          {chapterBanners && (
            <div class="card">
            <Toolbar
            className="mb-4"
            left={leftToolbarTemplateChapter}
          ></Toolbar>
            <DataTable
            ref={dt}
            value={chapterBanners}
            selection={selectedChapterBanners}
            onSelectionChange={(e) => setSelectedChapterBanners(e.value)}
            dataKey="_id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} banners"
            header={header}
          >
            <Column selectionMode="multiple" exportable={false}></Column>
            <Column
              body={actionBodyTemplateChapterBanner}
              exportable={false}
              style={{ minWidth: "12rem" }}
            ></Column>
             <Column
              body={imageBodyTemplate}
              header="Image"
              style={{ minWidth: "12rem" }}
            ></Column>
            <Column
              header="Path"
              body={imageURLTemplate}
              style={{ minWidth: "12rem" }}
            ></Column>
          </DataTable> 
          </div>
          )}
        </div>
        {/*  END OF DATA TABLE  */}

        {/*  START OF DELETE FORM   */}
        <Dialog
          visible={deleteChapterBannerDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteChapterBannerDialogFooter}
          onHide={hideDeleteChapterBannerDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{ fontSize: "2rem" }}
            />
            {chapterBanner && (
              <span>
                Are you sure you want to delete <b>{imageName}</b> from 
                ?
              </span>
            )}
          </div>
        </Dialog>
        {/*  END OF DELETE FORM   */}

        {/*  START OF MULTIPLE DELETE FORM   */}
        <Dialog
          visible={deleteChapterBannersDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteChapterBannersDialogFooter}
          onHide={hideDeleteChapterBannersDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{ fontSize: "2rem" }}
            />
            {chapterBanner && (
              <span>
                Are you sure you want to delete the selected Chapter Banners?
              </span>
            )}
          </div>
        </Dialog>
        {/*  END OF MULTIPLE DELETE FORM   */}
    </AdminChapterTitlesBase>
  )
}

export default ChapterBanner

